import { render, staticRenderFns } from "./JdiButton.vue?vue&type=template&id=2e9b0b7a&"
import script from "./JdiButton.vue?vue&type=script&lang=ts&"
export * from "./JdiButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports